import React from 'react'
import HeroServiziPage from '../Components/Hero/HeroServiziPage';
import Servizi from '../Components/Servizi/ServiziPage';

const heroData = {
    bgImg: 'images/hero-bg.jpg',
    bgShape: 'shape/hero-shape.png',
    sliderImages: [
        {
            img: 'images/hero-img.png',
        },
        {
            img: 'images/hero-img1.png',
        },
        {
            img: 'images/hero-img2.png',
        },
        {
            img: 'images/hero-img.png',
        },
        {
            img: 'images/hero-img1.png',
        },
        {
            img: 'images/hero-img2.png',
        },
    ],
    title: "Medicina Estetica",
    description: "<h4>Trattamenti avanzati e non invasivi per valorizzare la bellezza naturale del viso e del corpo.</h4>"
        + "Offro soluzioni personalizzate per una pelle luminosa, tonica e curata: dal laser ai peeling, fino ai trattamenti antiage e idratanti. Percorsi su misura per migliorare inestetismi, rughe, cicatrici, lassit&agrave; e pigmentazioni, in totale sicurezza e benessere."
};

const ServiziData = {
    img:"/images/xray.png",
    content2: `
        <h4>Trattamenti per l&apos;Idratazione e il Glow della Pelle</h4>
        <ul>
          <li><strong>Risultati freschi e luminosi:</strong> Trattamenti specifici per donare idratazione profonda e un aspetto sano, luminoso e radioso, combattendo la pelle opaca e disidratata.</li>
        </ul>
       <h4>Pulizia Viso Medicale</h4>
                    <ul>
                      <li><strong>Pulizia profonda:</strong> Un trattamento ad alta precisione che rimuove impurit&agrave;, cellule morte e sebo in eccesso, purificando la pelle e migliorando l&apos;assorbimento dei prodotti cosmetici.</li>
                    </ul>

                    <h4>Lifting Non Invasivo</h4>
                    <ul>
                      <li><strong>Definizione e tonificazione:</strong> Lifting senza chirurgia per rassodare i tessuti e ridefinire i contorni del viso, stimolando la produzione di collagene e migliorando l&apos;elasticit&agrave; della pelle.</li>
                    </ul>

                    <h4>Trattamento con Laser Pixel CO2</h4>
                    <ul>
                      <li><strong>Rughe profonde e lassit&agrave;:</strong> Il laser Pixel CO2 agisce in profondit&agrave; per ridurre rughe marcate e migliorare la tonicit&agrave; della pelle, stimolando la produzione di nuovo collagene e restituendo compattezza.</li>
                    </ul>

                    <h4>Trattamenti per inestetismi Cutanei</h4>
                    <ul>
                      <li><strong>Fibromi:</strong> Rimozione sicura e precisa di fibromi cutanei attraverso tecnologie avanzate.</li>
                      <li><strong>Cicatrici:</strong> Trattamenti per ridurre l&apos;aspetto delle cicatrici, rendendo la pelle pi&ugrave; liscia e uniforme.</li>
                      <li><strong>Verruche e Cheratosi:</strong> Trattamenti per la rimozione di verruche e cheratosi cutanee, migliorando l&apos;aspetto della pelle.</li>
                      <li><strong>Neoformazioni Benigne e Condilomi:</strong> Trattamenti mirati per rimuovere neoformazioni benigne e condilomi, migliorando la salute e l&apos;estetica della pelle.</li>
                      <li><strong>Pigmentazioni Cutanee:</strong> Tecniche per ridurre le macchie scure e uniformare il tono della pelle, restituendo luminosit&agrave; al viso.</li>
                    </ul>

                    <p>Ogni trattamento &egrave; personalizzato in base alle esigenze del cliente, garantendo soluzioni efficaci e sicure per una pelle visibilmente migliorata.</p>

                    <h3>Trattamenti per il Corpo</h3>
                    <ul>
                      <li>Trattamenti corpo non invasivi per migliorare tonicit&agrave; e compattezza della pelle</li>
                      <li>Epilazione laser medicale definitiva per una rimozione sicura e duratura dei peli superflui</li>
                      <li>Laser per il trattamento degli inestetismi cutanei, come capillari visibili, macchie e cicatrici</li>
                    </ul>
                    <br><br><br><br>
    `,
    content1: `
        <h4>Offro trattamenti avanzati per il miglioramento estetico del viso e del corpo, con soluzioni sicure e non invasive per valorizzare la bellezza naturale di ogni donna.</h4>
        <br>
        <h3>TRATTAMENTI PER IL VISO</h3>
        <p>Offriamo una vasta gamma di trattamenti non invasivi e altamente efficaci per risolvere vari inestetismi della pelle e per ringiovanire il viso, garantendo risultati visibili e duraturi.</p>

        <h4>Peeling Chimico e Trattamenti Laser</h4>
        <ul>
          <li><strong>Rimozione di macchie cutanee:</strong> Trattamenti specifici per schiarire e uniformare il tono della pelle, eliminando macchie solari, lentiggini o discromie.</li>
          <li><strong>Cicatrici e segni del tempo:</strong> L&apos;utilizzo di peeling chimico e trattamenti laser aiuta a migliorare l&apos;aspetto di cicatrici, rughe e segni dovuti all&apos;invecchiamento, stimolando la rigenerazione cellulare.</li>
        </ul>
    `,
};

const AboutPage = () => {
  return (
    <>
      <HeroServiziPage data={heroData} />
      <Servizi data={ServiziData} />
    </>
  )
}

export default AboutPage
